import React, { useState } from "react";
import "../styles/Hero.scss";

import img1 from "../images/carousel/1.png";
import img2 from "../images/carousel/2.png";
import img3 from "../images/carousel/3.png";

const images = [img1, img2, img3];

export default function Hero() {
  const [activeImage, setActiveImage] = useState(0);

  return (
    <section className="ovit-hero">
      <div className="ovit-hero__container">
        {/* TEXTO */}
        <div className="ovit-hero__text">
          <h1 className="ovit-hero__title">
            Creamos Contenido y Campañas que Generan Ventas
          </h1>

          <h2 className="ovit-hero__subtitle">
            Estrategia digital enfocada en <span>resultados reales</span>
          </h2>

          <p className="ovit-hero__description">
            Atraemos clientes, posicionamos tu marca y convertimos visitas en
            ventas. Después potenciamos tu negocio con landing pages, apps y
            automatizaciones inteligentes.
          </p>

          <a
            href="https://wa.me/5215588093678?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20sus%20servicios.
"
            className="ovit-btn-primary"
          >
            Hablar por WhatsApp
          </a>
        </div>

        {/* IMAGEN GRANDE */}
        <div className="ovit-hero__visual">
          <div className="ovit-hero__mainImage">
            <img src={images[activeImage]} alt="Proyecto OVIT" />
          </div>

          <div className="ovit-hero__thumbs">
            {images.map((img, index) => (
              <div
                key={index}
                className={`ovit-thumb ${activeImage === index ? "active" : ""}`}
                onClick={() => setActiveImage(index)}
              >
                <img src={img} alt={`preview-${index}`} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* STATS CENTRADOS */}
      <div className="ovit-hero__stats">
        <div className="ovit-stat">
          <span className="ovit-stat__number">+10</span>
          <span className="ovit-stat__label">Años de experiencia</span>
        </div>

        <div className="ovit-stat">
          <span className="ovit-stat__number">+800</span>
          <span className="ovit-stat__label">Proyectos completados</span>
        </div>

        <div className="ovit-stat">
          <span className="ovit-stat__number">+400</span>
          <span className="ovit-stat__label">Clientes satisfechos</span>
        </div>
      </div>
    </section>
  );
}
